import api from "api/api";

export const createSubcontractorCompanyQuery = async ({ data, userScope }) =>
  await api.post(`/directory/subcontractor_company?scope=${userScope}`, data);

export const getSubcontractorCompanyQuery = async ({ id, userScope }) =>
  await api.get(`/directory/subcontractor_company/${id}?scope=${userScope}`);

export const updateSubcontractorCompanyQuery = async ({ id, data, userScope }) =>
  await api.put(`/directory/subcontractor_company/id/${id}?scope=${userScope}`, data);

export const getSubcontractorCompanyByIdArrayQuery = async ({ ids, userScope }) =>
  await api.get(`/directory/subcontractor_company/ids/${ids}?scope=${userScope}`);

export const searchSubcontractorCompanyByNameQuery = async ({ search, userScope }) =>
  await api.get(`/directory/search/subcontractor_company?search=${search}&scope=${userScope}`);

export const deleteSubcontractorCompanyQuery = async ({ id, userScope }) =>
  await api.delete(`/directory/subcontractor_company/id/${id}?scope=${userScope}`);

export const getSubcontractorCompanyBySlugQuery = async ({ slug, userScope }) =>
  await api.get(`/directory/subcontractor_company/slug/${slug}?scope=${userScope}`);

export const getSubcontractorCompaniesByFiltersQuery = async ({
  isMultipleIds,
  filters,
  userScope,
}) => {
  const searchParams = new URLSearchParams();
  searchParams.append("scope", userScope);
  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((e) => e && searchParams.append(key, e));
    } else {
      value && searchParams.append(key, value);
    }
  });
  const queryString = searchParams.toString().replaceAll("%2C", ",");
  return await api.get(
    `/directory/subcontractor_company/filter${
      isMultipleIds ? "/multiple" : ""
    }?${queryString}`
  );
};

export const generateSubcontractorListCSVQuery = async ({ company_id, userScope }) =>
  api.post(`/directory/subcontractor_company/${company_id}/subcontractors_csv?scope=${userScope}`);

export const getSubcontractorsListExportQuery = async ({ file_id }) =>
  api.getBlob(`/file/${file_id.uri}`);
